import humps from 'humps';
import vue from 'vue';

const legalPerson = [{
  firstName: '',
  lastName: '',
  idCardNumber: '',
  birthDate: '',
  nationality_country_id: '',
  residency_country_id: '',
}];

const formData = [{
  firstName: '',
  lastName: '',
  idCardNumber: '',
  birthDate: '',
  nationality_country_id: '',
  residency_country_id: '',
}];

export default {
  namespaced: true,
  state: {
    data: legalPerson,
    formErrors: {},
    form: formData,
  },
  mutations: {
    set(state, payload) {
      if (payload.length) {
        const serverLegalPeople = humps.camelizeKeys(payload);
        const newState = [];
        const newErrors = [];
        serverLegalPeople.forEach((serverLegalPerson, index) => {
          newState.push({});
          newErrors.push({});
          Object.keys(serverLegalPerson).forEach((key) => {
            newState[index][key] = serverLegalPerson[key];
          });
          newState[index].nationality_country_id = serverLegalPerson.nationalityCountryId;
          newState[index].residency_country_id = serverLegalPerson.residencyCountryId;
        });

        vue.set(state, 'formErrors', newErrors);
        vue.set(state, 'data', newState);
        vue.set(state, 'form', newState);
        setTimeout(() => {
          if (typeof window.Materialize !== 'undefined') {
            window.Materialize.updateTextFields();
          }
        }, 500);
      }
    },
    setFormValue(state, payload) {
      if (payload.field === 'residencyCountry') {
        Object.assign(state.form[payload.index], { residency_country_id: payload.value.id });
      } else if (payload.field === 'nationalityCountry') {
        Object.assign(state.form[payload.index], { nationality_country_id: payload.value.id });
      } else {
        Object.assign(state.form[payload.index], { [payload.field]: payload.value });
      }
    },
    add(state) {
      state.form.push({
        firstName: '',
        lastName: '',
        idCardNumber: '',
        birthDate: '',
        nationality_country_id: '',
        residency_country_id: '',
      });
    },
    remove(state, index) {
      state.form.splice(index, 1);
    },
    setErrors(state, formErrors) {
      const newErrors = {};
      Object.keys(formErrors).forEach((key) => {
        if (key.indexOf('legal_person') === 0) {
          const keyArray = key.split('.');
          if (typeof newErrors[keyArray[1]] === 'undefined') {
            newErrors[keyArray[1]] = {};
          }
          newErrors[keyArray[1]][humps.camelize(keyArray[2])] = formErrors[key];
        }
      });
      Object.assign(state, { formErrors: newErrors });
    },
  },
  actions: {
    set(context, payload) {
      context.commit('set', payload);
    },
    validate(context) {
      context.commit('save', { validateOnly: true });
    },
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
    add(context) {
      context.commit('add');
    },
    remove(context, index) {
      context.commit('remove', index);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/legalPeople.js